import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const confirmationHeaderCss = "clqv9uu";
export const ConfirmationHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(confirmationHeaderCss, props.className)} />;
});
const confirmationTitleCss = "c1iko4jb";
export const ConfirmationTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h2';
  return <Component ref={ref} {...restProps} className={classNames(confirmationTitleCss, props.className)} />;
});
const subtextCss = "s1jtztq2";
export const Subtext = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(subtextCss, props.className)} />;
});
const reasonButtonCss = "r18aoj33";
export const ReasonButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(reasonButtonCss, props.className)} />);
const headerInnerCss = "h129m3r5";
export const HeaderInner = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerInnerCss, props.className)} />;
});
const labelGrayCss = "l1vnw3qj";
const labelCss = "lu2zzt5";
export const Label = forwardRef((props, ref) => {
  const {
    gray,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, {
    [labelGrayCss]: gray
  }, props.className)} />;
});
const messageCss = "m5t4jce";
export const Message = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(messageCss, props.className)} />;
});
const warningSubtextCss = "wwgv9dy";
export const WarningSubtext = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(warningSubtextCss, props.className)} />;
});
const stepIndicatorCss = "syjd5q7";
export const StepIndicator = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(stepIndicatorCss, props.className)} />;
});
const progressBarWrapperCss = "pwp8klu";
export const ProgressBarWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(progressBarWrapperCss, props.className)} />;
});
const progressBarCss = "p4d4mcb";
const progressSegmentCss = "phl5qb7";
export const ProgressBar = ({
  step,
  total
}) => {
  const segments = Array.from({
    length: total
  }, (_, i) => i + 1);
  return <div className={progressBarCss}>
      {segments.map(s => <div key={s} className={progressSegmentCss} data-active={s <= step} />)}
    </div>;
};

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");